import { makeAutoObservable } from "mobx";
import { IItem, ISimpleResponce } from "@drone-parts.garphild.pro/interfaces";
import RestApiQuery, { ApiEndpoints } from "../helpers/rest-api-query";
import { notification } from "antd";

class ItemsStorage {
  items: IItem[] = [];
  constructor() {
    makeAutoObservable(this);
  }

  loadItems = async () => {
    try {
      const response = await RestApiQuery.get<ISimpleResponce<IItem[]>>(ApiEndpoints.Items);
      if (!response) {
        throw new Error('Failed to load items');
      }

      this.items = response.data.map(item => {
        return {
          ...item,
          // partTypeId: Array.isArray(item.partTypeId) ? item.partTypeId : [item.partTypeId],
        };
      })
    } catch (error: any) {
      notification.error({ message: error.message });
    }
  }

  handleChangePartType = async (_id: string, value: any) => {
    try {  
      const response = await RestApiQuery
        .put<Partial<IItem>, { data: IItem[] }>(ApiEndpoints.Items, { _id, partTypeId: value });

      if (!response) {
        throw new Error('Failed to change part type');
      }
      const currentItem = this.items.find(item => item._id === _id);
      if (!currentItem) {
        throw new Error('Item not found');
      }
      currentItem.partTypeId = value;
      this.items = [...this.items];

      return response.data;
    } catch (error: any) {
      notification.error({ message: error.message });
    }
  }
}

const itemsStorage = new ItemsStorage();

export default itemsStorage;
